module.exports = "<textarea #message id=\"text-message-response\"\n          [ngClass]=\"className\"\n          [disabled]=\"disabled\"\n          [value]=\"text\"\n          (paste)=\"onPaste($event)\"\n          (focus)=\"enterTextArea()\"\n          (blur)=\"exitTextArea($event)\"></textarea>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/textbox/textbox.component.html
// module id = ./src/app/shared/textbox/textbox.component.html
// module chunks = main